import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Response } from '../models/response';
import { environment } from 'src/environments/environment';
import { EditProject, SingleProject } from '../models/project';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const API = `${environment.api}/projects/`;
const newAPI = `${environment.api}/projectUser/`;
const azure_API = `${environment.api}/azuredevops/`;

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  constructor(private readonly http: HttpClient) {}

  getProject(filter: {
    status: string;
    priority: string;
    filter_search: string;
    is_course: number;
  }): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);

    return this.http.get<any>(API + 'index', {
      context,
      params: new HttpParams()
        .set('status', filter.status)
        .set('priority', filter.priority)
        .set('filter_search', filter.filter_search)
        .set('is_course', filter.is_course)
    });
  }

  getProjectData(body?: any): Observable<any> {
    return this.http.post<any>(API + 'index', body);
  }

  showProject(alias: any): Observable<any> {
    return this.http.get<any>(API + `${alias}/showAlias`);
  }

  myProjects(year: any = '', month: any = '') {
    return this.http.get<any>(API + 'myProjects', {
      params: new HttpParams().set('year', year).set('month', month)
    });
  }

  addProject(project: any): Observable<Response<any>> {
    return this.http.post<any>(API + 'createProject', project);
  }

  editPrj(id: number, project: any): Observable<EditProject> {
    return this.http.post<EditProject>(API + `projectUpdate/${id}`, project);
  }

  getStatusPrj() {
    return this.http.get<any>(API + 'getStatus');
  }

  getPriorityProject() {
    return this.http.get<any>(`${API}getPriority`);
  }

  deletePrj(id: number): Observable<SingleProject> {
    return this.http.delete<SingleProject>(API + `${id}/destroy`);
  }

  getProjectTimesheet() {
    return this.http.get<any>(API + 'getBillableProjects');
  }

  postTeamassessment(data: any): Observable<EditProject> {
    return of({} as EditProject);
  }

  getAssessment(sprint_id: number) {
    return of([]);
  }

  getTeamassassmentData(project_id: any, start?: any, end?: any) {
    return of({
      labels: [],
      dataArray: [
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] }
      ]
    });
  }
  setHasCsv(sprintID: number): Observable<any> {
    return this.http.post(`${API}${sprintID}/setHasCsv`, {});
  }

  getBugCounts(): Observable<any[]> {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    return this.http.get<any[]>(`${API}fetchBugs`, {
      context: new HttpContext().set(CONFIG, config)
    });
  }

  addProjectTimesheet(project: any) {
    return this.http.post<any>(API + 'storeBillableProject', project);
  }

  updateProjectTimesheet(project: any, id: any) {
    return this.http.post<any>(API + `updateBillableProject/${id}`, project);
  }

  countPBIs(): Observable<any[]> {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    return this.http.get<any[]>(`${azure_API}countPBIs`, {
      context: new HttpContext().set(CONFIG, config)
    });
  }
  getDevProjects() {
    return this.http.get<any>(API + `getDevProjects`);
  }

  getDesignerProjects() {
    return this.http.get<any>(API + `getDesignerProjects`);
  }
}
